import { Routes } from '@angular/router';
import {
  abTestApplianceDetailsConversationalGuard,
  hasCheckoutContract,
  hasQuoteGuard,
  hasQuoteResponseNoContentGuard,
  hasRegisteredItemGuard,
  hasRegisteredItemProductsGuard,
  hasRegistrationRequestGuard,
} from '@us-registration/data-access';
import {
  RegistrationFeature,
  RegistrationRoutes,
} from '@us-registration/util-models';
import { wibMatcher } from './wib-matcher/wib.matcher';

export const US_REGISTRATION_ROUTES: Routes = [
  {
    path: 'appliance-details',
    loadChildren: () =>
      import('@us-registration/feature-appliance-details-stepped-wib').then(
        (module) =>
          module.REGISTRATION_FEATURE_APPLIANCE_DETAILS_STEPPED_WIB_ROUTES
      ),
    canMatch: [wibMatcher],
  },
  {
    path: 'appliance-details',
    loadChildren: () =>
      import('@us-registration/feature-appliance-details-conversational').then(
        (module) =>
          module.REGISTRATION_FEATURE_APPLIANCE_DETAILS_CONVERSATIONAL_ROUTES
      ),
    canMatch: [abTestApplianceDetailsConversationalGuard],
  },
  {
    path: 'appliance-details',
    loadChildren: () =>
      import('@us-registration/feature-appliance-details-stepped').then(
        (module) => module.REGISTRATION_FEATURE_APPLIANCE_DETAILS_STEPPED_ROUTES
      ),
  },
  {
    path: 'protection-details',
    loadChildren: () =>
      import('@us-registration/feature-protection-details-wib').then(
        (module) => module.REGISTRATION_FEATURE_PROTECTION_DETAILS_WIB_ROUTES
      ),
    data: {
      redirectTo: RegistrationRoutes.ApplianceDetails,
    },
    canMatch: [wibMatcher],
    canActivate: [hasQuoteGuard],
  },
  {
    path: 'coverage-info',
    loadChildren: () =>
      import('@us-registration/feature-coverage-info-conversational').then(
        (module) => module.UsRegistrationFeatureCoverageInfoConversationalModule
      ),
    data: {
      redirectTo: RegistrationRoutes.ApplianceDetails,
    },
    canActivate: [hasRegisteredItemGuard, hasRegisteredItemProductsGuard],
  },
  {
    path: 'benefits',
    loadChildren: () =>
      import('@us-registration/feature-benefits-conversational').then(
        (module) => module.FeatureBenefitsConversationalModule
      ),
    data: {
      redirectTo: RegistrationRoutes.ApplianceDetails,
    },
    canActivate: [hasRegisteredItemGuard, hasRegisteredItemProductsGuard],
  },
  {
    path: 'protection-details',
    loadChildren: () =>
      import('@us-registration/feature-protection-details').then(
        (module) => module.REGISTRATION_FEATURE_PROTECTION_DETAILS_ROUTES
      ),
    data: {
      redirectTo: RegistrationRoutes.ApplianceDetails,
    },
    canActivate: [hasRegisteredItemGuard, hasRegisteredItemProductsGuard],
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('@us-registration/feature-checkout').then(
        (module) => module.REGISTRATION_FEATURE_CHECKOUT_ROUTES
      ),
    data: {
      redirectTo: RegistrationRoutes.ApplianceDetails,
    },
    canMatch: [wibMatcher],
    canActivate: [hasQuoteGuard],
  },
  {
    path: 'confirmation',
    loadChildren: () =>
      import('@us-registration/feature-registration-confirmation-wib').then(
        (module) => module.REGISTRATION_FEATURE_CONFIRMATION_WIB_ROUTES
      ),
    data: {
      redirectTo: RegistrationRoutes.ApplianceDetails,
      feature: RegistrationFeature.RegistrationConfirmationPage,
    },
    canMatch: [wibMatcher],
    canActivate: [hasQuoteResponseNoContentGuard],
  },
  {
    path: 'confirmation',
    loadChildren: () =>
      import('@us-registration/feature-registration-confirmation').then(
        (module) => module.REGISTRATION_FEATURE_CONFIRMATION_ROUTES
      ),
    data: {
      redirectTo: RegistrationRoutes.ApplianceDetails,
      feature: RegistrationFeature.RegistrationConfirmationPage,
    },
    canActivate: [hasRegistrationRequestGuard],
  },
  {
    path: 'order-confirmation',
    loadChildren: () =>
      import(
        '@us-registration/feature-registration-order-confirmation-wib'
      ).then(
        (module) => module.REGISTRATION_FEATURE_ORDER_CONFIRMATION_WIB_ROUTES
      ),
    data: {
      redirectTo: RegistrationRoutes.ApplianceDetails,
    },
    canMatch: [wibMatcher],
    canActivate: [hasQuoteGuard, hasCheckoutContract],
  },
  {
    path: 'order-confirmation',
    loadChildren: () =>
      import('@us-registration/feature-registration-order-confirmation').then(
        (module) => module.REGISTRATION_FEATURE_ORDER_CONFIRMATION_ROUTES
      ),
    data: {
      redirectTo: RegistrationRoutes.ApplianceDetails,
    },
    canActivate: [hasRegisteredItemGuard, hasRegisteredItemProductsGuard],
  },
  // NOTE: This redirect is required because the client has already printed the /2yearparts link in materials.
  // We are not using the Magnolia static page route directly, but redirecting to the support route instead.
  {
    path: '2yearparts',
    redirectTo: '/support/2yearparts',
  },

  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'appliance-details',
  },
];
